import firebase from "@/firebase/";
const firestore = firebase.firestore();
const users = firestore.collection("users");
import { getExtraUserData } from "@/helper_functions";

export default {
  async userCreate(
    { commit },
    { email, password, name, surname, organisation, justification }
  ) {
    try {
      // Create user
      let user = await firebase
        .auth()
        .createUserWithEmailAndPassword(email, password);
      user = user.user;

      // Create user record for personal information
      await users.doc(user.uid).set({
        name,
        surname,
        organisation,
        justification
      });

      // Load extra user information
      let extraInfo = await getExtraUserData(user.uid);

      // Add information to user object
      user = { ...user, ...extraInfo };

      // Commit the mutations
      commit("setUser", user);
      commit("registerButtonLoading", false);
    } catch (e) {
      commit("setUser", null);
      commit("registerButtonLoading", false);
      if (e.code == "auth/email-already-in-use") {
        commit(
          "setRegistrationError",
          "This email already exists. Please use a different one for registration or reset your password."
        );
      } else {
        commit(
          "setRegistrationError",
          "An error was encountered. Please make sure your credentials are correct and try again."
        );
      }
    }
  },
  async userLogin({ commit }, { email, password }) {
    try {
      // Get user
      let user = await firebase
        .auth()
        .signInWithEmailAndPassword(email, password);
      user = user.user;

      // Load extra user information
      let extraInfo = await getExtraUserData(user.uid);

      // Add information to user object
      user = { ...user, ...extraInfo };

      // Commit the mutations
      commit("setUser", { ...user });
      commit("setUserLoginError", "");
      commit("loginButtonLoading", false);
      commit("showLoginSuccess", true);
      setTimeout(() => {
        commit("showLoginSuccess", false);
      }, 3000);
    } catch (e) {
      commit("setUser", null);
      commit("loginButtonLoading", false);
      if (e.code == "auth/wrong-password") {
        commit(
          "setUserLoginError",
          "The password you entered is wrong. Please try again or reset your password."
        );
      } else if (e.code == "auth/user-not-found") {
        commit(
          "setUserLoginError",
          "There is no user corresponding to this email address. Please request access if you do not have an account."
        );
      } else {
        commit(
          "setUserLoginError",
          "An error was encountered. Please make sure your credentials are correct and try again."
        );
      }
    }
  },
  userLogout({ commit }) {
    firebase
      .auth()
      .signOut()
      .then(() => {
        commit("setUser", null);
      });
  }
};
